import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const ButtleFlowStep4 = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <section>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='gameflow button'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-step4.webp`}
                />
            </div>{' '}
            <div className='flex justify-center mt-12'>
                <img
                    className=''
                    alt='One more'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-lift-throw.webp`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full px-4 md:px-0 md:w-4/5 mx-auto mt-12'>
                <p className=' '>
                    <span className='text-pborange'>Lift</span> an item on the map to equip it. You can also{' '}
                    <span className='text-pborange'>steal</span> items enemies are carrying as well as{' '}
                    <span className='text-pborange'>lift and equip the enemies themselves</span>! You can also{' '}
                    <span className='text-pborange'>Throw</span> items you have Lifted. You can even Throw your weapon
                    to unequipped allies, and then they can equip it! You can also Throw enemies outside of the map,
                    which is called <span className='text-pborange'>O.B.</span>, and they will sustain damage!
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 1,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Throw a powerful weapon to a barehanded ally, and it can be used by multiple allies! Use your
                        creativity to conjure up even more ways to use this action!'
                />{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 2,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="If you equip an enemy character you have Lifted to an ally, they will be unable to act, and your
                        character will use them as a shield when attacked. It's a great way to kill two birds with one
                        stone!"
                />{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 3,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='If you Throw a Lifted enemy off the map, they will go O.B. This is a great way to put some
                        distance between allies and the enemy, as well as inflict damage.'
                />{' '}
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='One more'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-confire.webp`}
                    />
                </div>{' '}
                <p className='mt-8'>
                    Apricot can summon things like Barrelbots, Peashooters, and Ded Zeppelins. These are called{' '}
                    <span className='text-pborange'>Gadget</span>. If you Confine an allied Phantom to a Gadget, you
                    will be able to use that Gadget's <span className='text-pborange'>unique skills</span> to attack.
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 4,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='If Apricot uses Gadget Drop and then Marona Confines an ally...'
                />{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 5,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                />{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 6,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='...a powerful unit is born! Use skills that only Gadgets have access to in order to find the way forward!'
                />{' '}
                <div className='flex justify-center mt-12'>
                    <img
                        className=''
                        alt='One more'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-confriend.webp`}
                    />
                </div>{' '}
                <p className='mt-8'>
                    <span className='text-pborange'>Marona can Confine Phantoms</span> she has formed deep bonds with
                    within herself. This is called <span className='text-pborange'>Confriend</span>!
                </p>{' '}
                <p className=' '>
                    In addition to having increased stats when using Confriend, Marona will also be able to use{' '}
                    <span className='text-pborange'>special techniques</span>! Not only that but as you further increase
                    Marona's Friendship, she will be able to attack <span className='text-pborange'>AGAIN</span>!
                    Execute consecutive repeat attacks to give Marona increasingly more{' '}
                    <span className='text-pborange'>powerful buffs</span>!
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 7,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="The higher Marona's Friendship with an ally, the more consecutive repeat attacks you can use when using Confriend!"
                />{' '}
                <p className=' '>
                    Friendship can be raised by talking to allies at your home base or deploying them in battle. You can
                    also give them gifts!
                </p>{' '}
                <p className=' '>
                    When using Confriend, you will have access to extra powerful techniques, allowing you to turn a
                    tough situation into a victory!
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'flow-4',
                            index: 8,
                        },
                        {
                            modalId: 'flow-4',
                            index: 9,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description='Wipe out the enemy with powerful and fabulous Confriend Techniques!'
                />{' '}
                <p className=' '>Use all kinds of attacks to defeat your foes!</p>{' '}
            </div>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={9}
            />
        </section>
    )
}
